module.exports = __webpack_public_path__ + "media/flags/tn-5b18c008.svg";